"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { BookOpen, Heart, ShieldCheck, Sparkles, Star, Sun } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VeteranOwnedReliability() {
  const headerReveal = useRevealOnScroll<HTMLDivElement>();
  const contentReveal = useRevealOnScroll<HTMLDivElement>();
  const statsReveal = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    icon: "book",
    number: "24/7",
    label: "AI Answering Support",
    bg: "bg-blue-600/20",
    iconColor: "text-blue-600",
    rotation: "rotate-0"
  }, {
    icon: "sun",
    number: "100%",
    label: "Veteran Operated",
    bg: "bg-orange-500/20",
    iconColor: "text-orange-500",
    rotation: "rotate-0"
  }, {
    icon: "heart",
    number: "10x",
    label: "CLIENT BOOKING",
    bg: "bg-blue-600/20",
    iconColor: "text-blue-600",
    rotation: "rotate-0"
  }, {
    icon: "star",
    number: "Elite",
    label: "Premium Brand Design",
    bg: "bg-orange-500/20",
    iconColor: "text-orange-500",
    rotation: "rotate-0"
  }];
  const teachers = [{
    name: "Founder",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/founder_father.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/founder_father.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/founder_father.webp-wvc-sizes"
  }, {
    name: "Partner",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/founder_son.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/founder_son.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/founder_son.webp-wvc-sizes"
  }];
  const renderIcon = (icon: string, className: string) => {
    if (icon === "book") return <BookOpen className={className} />;
    if (icon === "sun") return <Sun className={className} />;
    if (icon === "heart") return <Heart className={className} fill="currentColor" />;
    return <Star className={className} fill="currentColor" />;
  };
  return <section data-section-id="319" id="veteran-owned-reliability" className="relative overflow-hidden bg-background py-20 md:py-28 lg:py-[7rem]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute top-20 left-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-lg bg-blue-600/5 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={headerReveal.ref} className={`text-center transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="inline-flex items-center gap-2 font-mono text-xs md:text-sm uppercase tracking-[0.25em] text-blue-600">
            
            
          </div>

          <h2 className="font-default mt-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-foreground">
            Precision tools,
            <br />
            <span className="italic font-light text-blue-600">mission success.</span>{" "}
            <span className="italic font-light"></span>
          </h2>
        </div>

        {}
        <div ref={contentReveal.ref} className={`mt-16 md:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 transition-all duration-700 ease-out ${contentReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="lg:col-start-2 lg:col-span-6">
            <p className="font-default text-xl md:text-2xl leading-relaxed text-foreground/85">At AI Guyz, we provide the tactical services local businesses need to dominate their market. As a veteran-owned father-son team in Vacaville, we provide high-performance services that eliminate missed calls and streamline your client acquisition. We turn your business into a premium brand, putting your business on autopilot so you can focus on the mission.</p>
          </div>

          {}
          <div className="lg:col-start-9 lg:col-span-4 flex flex-col items-start lg:items-end justify-end gap-4">
            <div className="flex -space-x-3">
              {teachers.map((t, i) => <SafeHydrate><Avatar key={i} data-index={i} className="size-12 border-2 border-background shadow-md">
                  
                  
                </Avatar></SafeHydrate>)}
            </div>
            <p className="font-default italic text-lg md:text-xl text-foreground/70 lg:text-right">
              Mission ready,
              <br />
              <span className="text-blue-600">the AI Guyz team</span>
            </p>
          </div>
        </div>

        {}
        <div ref={statsReveal.ref} className={`mt-16 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 transition-all duration-700 ease-out ${statsReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {stats.map((stat, i) => <div key={i} data-index={i} className={`group relative bg-card rounded-lg p-6 md:p-7 shadow-md hover:shadow-lg transition-all duration-300`}>
              <div className={`inline-flex items-center justify-center size-12 md:size-14 rounded-lg ${stat.bg} mb-5 shadow-sm`}>
                {renderIcon(stat.icon, `size-6 md:size-7 ${stat.iconColor}`)}
              </div>
              <div className="font-default text-3xl md:text-4xl lg:text-5xl font-medium text-foreground leading-none">
                {stat.number}
              </div>
              <div className="mt-3 font-mono text-xs md:text-sm uppercase tracking-wider text-muted-foreground">
                {stat.label}
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-20 md:mt-24 flex justify-center">
          
        </div>
      </div>
    </section>;
}